export enum FileStatus {
  done = "done",
  rejectedFileType = "rejected_file_type",
  fileTooLarge = "error_file_size",
}
